import { InputContainer } from 'components/inputContainer/inputContainer';

import template from './giftCardChips.html';
import './giftCardChips.scss';

export const GiftCardChips = angular
    .module('checkout.components.orderSummary.giftCardChips', [
        InputContainer
    ]).component('giftCardChips', {
        template,
        bindings: {
            storeCreditInfo: '<',
            removeStoreCreditItem: '<'
        },
        controller: class GiftCardChipsCtrl {
            onRemoveClicked(code) {
                this.removeStoreCreditItem(code);
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/giftCardChips/giftCardChips.js